<template>
    <div>
        <highcharts
            v-if="loaded"
            :options="getOptions(chartOptions)"
            ref="chart"
        />

        <div v-else class="d-flex justify-content-center">
            <b-spinner :style="{'color':constants.spinnerColor}"></b-spinner>
        </div>
    </div>
</template>

<script>
    import {Chart} from 'highcharts-vue'
    import exportingInit from "highcharts/modules/exporting"
    import Highcharts from "highcharts"
    import dashboardChartMixin from '@/mixins/dashboardChartMixin'

    typeof exportingInit === 'function' && exportingInit(Highcharts);

    export default {
        name: 'EvolutionChart',
        mixins: [dashboardChartMixin],
        components: {
            highcharts: Chart
        },
        data() {
            return {
                loaded: false,
                chartName: "EvolutionOfStartups",
                chartData: [],
                chartOptions: {
                    chart: {
                        type: "column",
                        style: {
                            fontFamily: '"Overpass", sans-serif;',
                        },
                    },
                    title: {
                        text: "ATC evolution of startups"
                    },
                    xAxis: {
                        categories: [],
                        title: {
                            text: null
                        }
                    },
                    yAxis: {
                        min: 0,
                        title: {
                            text: "Number of startups added",
                            align: "high"
                        },
                    },
                    tooltip: {
                        valueSuffix: " startup(s)"
                    },
                    plotOptions: {
                        column: {
                            dataLabels: {
                                enabled: true,
                            },
                            events: {
                                click: (e) => {
                                    this.openStartupsModal(e.point.category)
                                }
                            }
                        }
                    },
                    series: [
                        {
                            name: "Year",
                            data: [],
                            colorByPoint: true,
                            colors: ['#043648', '#00afef', '#a50000', '#ffbf1c', '#0083b2', '#44bf2e', '#a11cff', '#ff5e1c']
                        }
                    ]
                }
            }
        },
        methods: {
            fetchChartData(initialCall = false) {
                if (!initialCall) {
                    this.$refs.chart.chart.showLoading()
                }

                this.getChartData('EvolutionOfStartups').then(response => {
                    this.chartData = response.data;
                    this.chartOptions.title.text = this.formatTitle(this.chartOptions.title.text);
                    this.formatAndSetChartData()

                    if (!initialCall) {
                        this.$refs.chart.chart.hideLoading()
                    } else {
                        this.loaded = true
                    }
                })
            },
            formatAndSetChartData() {
                let years = []
                let startupsCount = []

                this.chartData.forEach(item => {
                    years.push(item.category)
                    startupsCount.push(item.cnt)
                })

                this.chartOptions.xAxis.categories = years
                this.chartOptions.series[0].data = startupsCount

                // this.$refs.chart.chart.xAxis[0].setCategories(years, false)
                // this.$refs.chart.chart.series[0].setData(startupsCount, false)
                // this.$refs.chart.chart.redraw()
            },

            openStartupsModal(year) {
                this.$emit('showStartups', [this.chartName, this.formatTitle(`Startups added in ${year}`), year])
            },
        }
    }
</script>
